import React, { useState } from "react";
import { Tooltip, IconButton, HStack } from "@chakra-ui/react";
import { HiOutlinePlus } from "react-icons/hi";
import CodesetSelectCodeWithFilters from "../CodesetSelectCodeWithFilters";
import { HandleInsertHeading } from "../utils/HandleInsertHeading"; // named export

export default function HeadingInserter({ editor }) {
  const [selectedCode, setSelectedCode] = useState(null);

const onInsertClick = () => {
  if (!selectedCode) return;

  // Map your code object -> row fields
  const fieldId = selectedCode.longCode || "custom_field";
  const headingType = selectedCode.typeCode || "CustomHeading";
  const headingText = String(selectedCode.description1 || "HEADING").toUpperCase();

  HandleInsertHeading(editor, {
    fieldId,
    headingType,
    headingText,
    contentText: "None",
    fontSize: "12px", // Use px instead of pt for consistency with editor
    editableBy: ["insurer"],
  });
};

return (
  <HStack alignItems="center" justifyContent="center" width="100%">
    <CodesetSelectCodeWithFilters
      label=""
      codesetCode="MRCAI007"
      value={selectedCode}
      onChange={setSelectedCode}
      size="xs"
      height="32px"
    />

    <Tooltip label="Insert Heading...">
      <IconButton
        onClick={onInsertClick}
        icon={<HiOutlinePlus />}
        variant="outline"
        size="sm"
        bg="white"
        border="1px solid"
        borderColor="gray.300"
        _hover={{ bg: "gray.100" }}
        minW="2.5rem"
        isDisabled={!selectedCode}
        alignSelf="flex-start"
      />
    </Tooltip>
  </HStack>
);
}
